import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { QrDisplayConfig } from "../../types/qr-display-config";
import { QrDisplayConfigSelect } from "./qr-display-config-select";

interface ApplyQrDisplayConfigBarProps {
  configs: QrDisplayConfig[];
  selectedConfigId: number | "";
  onSelectedConfigIdChange: (qrDisplayConfigId: number | "") => void;
  onApplyToAll: () => void;
  disabled?: boolean;
  applying?: boolean;
  light?: boolean;
  employeesCount?: number;
}

export function ApplyQrDisplayConfigBar({
  configs,
  selectedConfigId,
  onSelectedConfigIdChange,
  onApplyToAll,
  disabled,
  applying,
  light,
  employeesCount = 0,
}: ApplyQrDisplayConfigBarProps) {
  const { t } = useTranslation();
  const cannotApplyToAll = employeesCount < 2;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className={`text-sm whitespace-nowrap ${light ? "text-gray-700" : "text-white"}`}>
        {t("employee.qr-config.apply-all")}
      </span>
      <QrDisplayConfigSelect
        configs={configs}
        value={selectedConfigId}
        placeholder={t("employee.qr-config.select")}
        onChange={onSelectedConfigIdChange}
        disabled={disabled || applying || cannotApplyToAll}
      />
      <Button
        variant="contained"
        disabled={disabled || applying || selectedConfigId === "" || cannotApplyToAll}
        onClick={onApplyToAll}
        title={cannotApplyToAll ? t("employee.qr-config.apply-all-min") : undefined}
        sx={{
          background: "#2d2f32",
          textTransform: "none",
          fontFamily: "Montserrat",
          borderRadius: "999px",
          "&:hover": { background: "#3d3f42" },
        }}
      >
        {t("employee.qr-config.apply")}
      </Button>
    </div>
  );
}
